'use client';

import { useEffect } from 'react';
import { capturePostHogException } from '@/analytics/posthog';
import { reloadOnceForChunkError } from '@/utils/chunkReload';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    capturePostHogException(error);
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>500</h1>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Something went wrong</h2>
            <p style={{ marginBottom: '1rem' }}>{error?.message || 'An unexpected error occurred'}</p>
            <button onClick={reset}>Try Again</button>
          </div>
        </div>
      </body>
    </html>
  );
}